export * from "./LighthouseIllustration";
